import React from 'react';
import { TextButton } from 'wix-ui-tpa/cssVars';
import { Filter as FilterIcon } from '@wix/wix-ui-icons-common/on-stage';
import { classes } from './FiltersModal.st.css';
import { countSelectedFilterOptions } from '../utils';
import { FilterModalDataHooks } from './const';
import { FiltersViewModel } from '../../../../components/DailyAgenda/viewModel/filtersViewModel/filtersViewModel';

export const FiltersModalButton: React.FC<{
  filtersViewModel?: FiltersViewModel;
  onOpen: () => void;
}> = ({ filtersViewModel, onOpen }) => {
  const filters = filtersViewModel?.filters ?? [];
  const numberOfActiveFilters = countSelectedFilterOptions(filters);

  return (
    <TextButton
      prefixIcon={<FilterIcon className={classes.filterModalCTASuffix} />}
      data-hook={FilterModalDataHooks.OPEN_BUTTON}
      onClick={onOpen}
      className={classes.openDialogButton}
    >
      {numberOfActiveFilters > 0 && (
        <span className={classes.appliedIndicator} />
      )}
    </TextButton>
  );
};
